import { useQuery } from '@tanstack/react-query';
import supportApi from 'api/helpdesk/supportApi';
import { notification } from 'constants/notification';
import { useApp } from 'context/AppContext';
import { Dialog } from 'primereact/dialog';
import { TabPanel, TabView } from 'primereact/tabview';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { RequestSupportAdd } from './RequestSupportAdd';
import { RequestSupportList } from './RequestSupportList';

export const RequestSupportDialog = ({ visible, onHideDialog }) => {
    const intl = useIntl();
    const { showAlert } = useApp();

    const { data: resSupport, isFetching } = useQuery({
        queryKey: ['supportData'],
        queryFn: () => {
            return supportApi.getUrl();
        },
    });
    useEffect(() => {
        if (resSupport && isFetching) {
            const { status, message } = resSupport;
            if (status === 1) {
            } else {
                showAlert('error', notification.FAIL, message);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resSupport, isFetching]);

    const dataSupport = resSupport?.data;

    const arrayTab = [
        {
            code: 1,
            header: intl.formatMessage({ id: 'add' }),
            component: <RequestSupportAdd dataSupport={dataSupport} />,
        },
        {
            code: 2,
            header: intl.formatMessage({ id: 'common.list' }),
            component: <RequestSupportList dataSupport={dataSupport} />,
        },
    ];

    return (
        <div className="dialog-css">
            {dataSupport && (
                <Dialog
                    visible={visible}
                    header={intl.formatMessage({ id: 'common.requestSupport' })}
                    modal
                    className="p-fluid p-dialog-default p-dialog-lg p-dialog-xl wr--70"
                    onHide={onHideDialog}
                    maximizable
                >
                    <TabView>
                        {arrayTab.map((item) => (
                            <TabPanel header={item.header} key={item.code}>
                                {item.component}
                            </TabPanel>
                        ))}
                    </TabView>
                </Dialog>
            )}
        </div>
    );
};
